export default __webpack_public_path__ + "static/media/130211savithri.a588d5eb.jpg";